export default "__VITE_ASSET__a2ed2a70__"